export const LabelDesignerTemplateGridPluginSettings: IPluginSettings = {
    name: 'Шаблоны этикеток',
    mnemocode: 'label_designer_template_plugin',
    permission: 'LabelDesigner',
    columns: [{
        order: 0,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 400
    },
    {
        order: 1,
        propertyName: 'contractorName',
        propertyType: 'string',
        displayName: 'Контрагент',
        visibility: true,
        width: 400
    },
    {
        order: 2,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 160
    },
    {
        order: 3,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 160
    },
    {
        order: 4,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: true,
        width: 160
    }
    ]
}